import * as React from "react";
import { Row, Col } from "reactstrap";
import { GoogleAnalyticsService } from "src/share/services/ga";
import { useInterval } from "src/share/hooks/useInterval";

export interface IGAActiveUsersProps {
  views: {
    query: {
      ids: string
    }
  }
}

export const GAActiveUsers: React.SFC<IGAActiveUsersProps> = (props) => {
  const [activeUsers, setActiveUsers] = React.useState<number | null>(null);
  const [counter, setCounter] = React.useState(0);
  const { clear, reset } = useInterval(async () => {
    try {
      const activeUsersResponse = await GoogleAnalyticsService.getActiveUsers(props.views.query.ids);
      setActiveUsers(activeUsersResponse);
    } catch (e) {
      setCounter(prevCounter => prevCounter + 1);
    }
  }, 10000);
  React.useEffect(() => {
    if (counter >= 3) {
      clear();
    }
  }, [counter]);
  React.useEffect(() => {
    setActiveUsers(null);
    clear();
    reset();
  }, [props.views.query.ids]);
  return (
    <div className='col-12 white-background col'>
      <Row>
        <Col className='col-12'>
          <h5 className="activeUsers">
            {activeUsers !== null && <>Active users right now: <span>{activeUsers}</span></>}
            {activeUsers === null && `Getting active users information ...`}
          </h5>
        </Col>
      </Row>
    </div>
  )
}
